export default __webpack_public_path__ + "static/media/xtreme-project-5.cd9cdee9.webp";